import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@/../environments/environment';

export interface CepResponse {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  cidade: string;
  uf: string;
}

@Injectable({
  providedIn: 'root'
})
export class CepService {
  private http = inject(HttpClient);

  /**
   * Busca informações de endereço pelo CEP
   * @param cep - CEP a ser consultado (com ou sem formatação)
   * @returns Observable com os dados do endereço
   */
  buscarCep(cep: string): Observable<CepResponse> {
    const cepLimpo = cep.replace(/\D/g, '');
    return this.http.get<CepResponse>(`${environment.apiUrl}/public/cep/${cepLimpo}`);
  }
}
